








import Component from "vue-class-component";
import Vue, { PropType } from "vue";
import { Prop } from "vue-property-decorator";
import { FormFields, FormValues } from "@/types";
import BaseFilter from "@/components/BaseFilter.vue";
import { Debounce, StoreInQuery } from "@/lib/helpers/customDecorators";

@Component({ components: { BaseFilter } })
export default class BaseQueryFilter extends Vue {
  @Prop({ required: true, type: Array as PropType<FormFields> })
  public readonly fields!: FormFields;

  @Prop({ type: String })
  public flexClass!: string;

  @Debounce(500)
  @StoreInQuery(["page"])
  public setQuery!: (values: FormValues) => void;

  public get values(): FormValues {
    const { query } = this.$route;
    let values: FormValues = {};
    this.fields.forEach(field => {
      values[field.name] = query[field.name] || null;
    });
    return values;
  }

  public set values(values: FormValues) {
    this.setQuery(values);
  }
}
